const FEEDBACK_EMAIL = 'experimentation-cs@spotify.com';
const MAX_MESSAGE_LENGTH = 500;

type Sentiment = 'positive' | 'negative' | 'comment';

interface FeedbackMailtoParams {
  sentiment: Sentiment;
  chatName: string;
  eventName: string;
  assistantMessage: string;
  userMessage?: string;
  chatUrl: string;
}

const sentimentLabels: Record<Sentiment, string> = {
  positive: 'Positive',
  negative: 'Negative',
  comment: 'Comment',
};

const truncate = (text: string, maxLength: number): string => {
  if (text.length <= maxLength) return text;
  return `${text.slice(0, maxLength)}... [truncated]`;
};

export type { Sentiment, FeedbackMailtoParams };

export const buildFeedbackMailto = ({
  sentiment,
  chatName,
  eventName,
  assistantMessage,
  userMessage,
  chatUrl,
}: FeedbackMailtoParams): string => {
  const subject = `[Chat feedback] ${sentimentLabels[sentiment]} — ${chatName}`;

  const bodyParts = [`Chat: ${chatUrl}`, `Event: ${eventName}`, ''];

  if (userMessage) {
    bodyParts.push('User question:', `> ${userMessage}`, '');
  }

  bodyParts.push(
    'Assistant response:',
    `> ${truncate(assistantMessage, MAX_MESSAGE_LENGTH)}`,
    '',
    '---',
    'Add your comments below:',
    '',
  );

  const body = bodyParts.join('\n');

  return `mailto:${FEEDBACK_EMAIL}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
};
